import {NSFunctions} from './utils/functions'
import {xCore} from './core';
import { NSPageLabels } from './page_labels';

export let NSPageBottompanel = {};

NSPageBottompanel.init = function()
{
    NSPageBottompanelPrivate.init();
	
	this.init = 	                    function () { return NSPageBottompanelPrivate.init.apply( NSPageBottompanelPrivate, arguments ); };
	this.f_show_bottompanel =	    	function () { return NSPageBottompanelPrivate.f_show_bottompanel.apply( NSPageBottompanelPrivate, arguments ); };
	this.f_hide_bottompanel =	    	function () { return NSPageBottompanelPrivate.f_hide_bottompanel.apply( NSPageBottompanelPrivate, arguments ); };

	window.NSPageBottompanelPrivate_ = NSPageBottompanelPrivate;	
}

let NSPageBottompanelPrivate = 
{
	private_objs: {
		s_e_div_bottompanel_holder_id: "bottompanel",
		e_div_bottompanel_holder: null,

        s_e_bottomtab_id: "bottomtab",
        e_resultspage: null
	},
	
	init: function()
	{
		let e_div_bottompanel_holder = document.getElementById(this.private_objs.s_e_div_bottompanel_holder_id);
		this.private_objs.e_div_bottompanel_holder = e_div_bottompanel_holder;

        this.f_create();
		
		this.initInterface();
		this.f_init_listners();
	},
	
	initInterface: function() {
		//Start bottompanel closed
		this.private_objs.e_div_bottompanel_holder.classList.add('collapsed');
		
		//Bottompanel expand button:
		var e_bottom_tab = document.getElementById("bottompanel-expand-button");
		e_bottom_tab.innerHTML = 
		`<div class="expand-button small up">
			<div class="direction-arrow-container">
				<div class="direction-arrow"></div>
			</div>
		</div>`;

		this.f_refresh_expand_button_icon();
	},

	f_init_listners: function()
	{	
		//Bottomtab Drawer toggle
        document.getElementById("bottompanel-expand-button").onclick = () =>
        {
			this.private_objs.e_div_bottompanel_holder.classList.toggle('collapsed');
			
			this.f_refresh_expand_button_icon();
		};
	},
	f_refresh_expand_button_icon: function()
	{
		let s_title_bottom_tab;
		var e_tab = document.querySelector("#bottompanel-expand-button .expand-button");
		let b_bottompanel_is_visible = this.f_bottompanel_is_visible();
		if(b_bottompanel_is_visible)
		{
            e_tab.classList.remove("up");
            e_tab.classList.add("down", "secondary");
			s_title_bottom_tab = NSPageLabels.f_get_label_text_by_internal_name('common_collapse');
		}
		else
		{
            e_tab.classList.add("up");
            e_tab.classList.remove("down", "secondary");
			s_title_bottom_tab = NSPageLabels.f_get_label_text_by_internal_name('common_expand');
		}
		
        e_tab.setAttribute("title", s_title_bottom_tab);
	},
	f_bottompanel_is_visible: function()
	{
        return !this.private_objs.e_div_bottompanel_holder.classList.contains('collapsed');
	},
	f_show_bottompanel: function()
	{
		let b_bottompanel_is_visible = this.f_bottompanel_is_visible();
		
		if(!b_bottompanel_is_visible)
		{
			this.private_objs.e_div_bottompanel_holder.classList.remove('collapsed')
		}
		
		this.f_refresh_expand_button_icon();
		
	},
	f_hide_bottompanel: function()
	{
		let b_bottompanel_is_visible = this.f_bottompanel_is_visible();

		if(b_bottompanel_is_visible)
		{
			this.private_objs.e_div_bottompanel_holder.classList.add('collapsed')
		}
		
		this.f_refresh_expand_button_icon();
	},
	
	f_create: function()
	{
		let private_objs = this.private_objs;
		
        let s_html = `
			<div id="bottompanel-expand-button"></div>
			<div id="bottompanel-content-container">
				<div id="resultspage" class="bottompanel-page"></div>
			</div>
		`;
		
		let e_div_bottompanel_holder = private_objs.e_div_bottompanel_holder;
		e_div_bottompanel_holder.innerHTML = "";
		NSFunctions.f_dom_elem_append_dom_childs_by_html(e_div_bottompanel_holder, s_html);

        private_objs.e_resultspage = document.getElementById("resultspage");
        
		//this.f_set_bottompanel_visibility();
		
		//this.f_set_buttons_behaviour();
	},
	f_set_bottompanel_visibility: function()
	{
		
	},
	f_set_element_display_: function(e_, b_display)
	{		
		e_.style.display = (b_display)? "" : "none";
	},
}